module.exports = __webpack_public_path__ + "static/lframe-home-reno-loan-7b42ddfa54564a966bfda99ae718a385.png";